// extracted by mini-css-extract-plugin
export default {"bannerTitle":"BannerTitle_bannerTitle__BsHIK"};